import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WaitingIndicatorService {
    private waitForTags: {
        [key: string]: boolean;
    } = {};
    /*
    So this is fine for now, but it is possible that blockScreen could be used by simultaneous
    API requests. In this case you might have a problem where one finishing requests
    prematurely deactivates the screen block. We elected not to act on this problem since it
    won't occur at this point.
    */
    public blockScreen = false;

    setWaitingTag(tagName: string, tagState: boolean) {
        this.waitForTags[tagName] = tagState;
    }
    isTagWaiting(tagName: string): boolean {
        return !!this.waitForTags[tagName];
    }
}
